module.exports = __webpack_public_path__ + "img/6-small.739297c3.png";